export default {
	list: 'Footnote',
	grid: {
		gridId: 'FootnoteGrid',
		height: 500,
		checkbox: false,
		edit: false,
		delete: true,
		pageSize: 100,
		groupable: true,
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false
		},
		FootnoteID: {
			class: 'value',
			dataName: 'FootnoteID',
			type: 'number',
			title: 'Footnote ID',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Footnote: {
			class: 'value',
			dataName: 'Footnote',
			type: 'string',
			title: 'Footnote',
			width: 600,
			hidden: false,
			readOnly: false
		},
	}
}